// @ts-nocheck
import createClass from 'create-react-class'
import FormBase from 'live/components/extensions/ui/form'
import React from 'react'
import FormGroup from 'live/components/forms/ui/form-group'
import i18n from 'live/services/i18n'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixinFactory from 'live/components/forms/mixins/object-initializer'

const ObjectInitializerMixin = ObjectInitializerMixinFactory('/rest/extension', {
    type: 'plugin-cameras',
    active: true,
    config: {
        baseUrl: '',
        authUrl: '',
        username: '',
        password: ''
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const validations = {
    properties: {
        config: {
            properties: {
                baseUrl: {
                    type: 'string',
                    required: true,
                    allowEmpty: false,
                    message: i18n('Base URL is required')
                },
                authUrl: {
                    type: 'string',
                    required: true,
                    allowEmpty: false,
                    message: i18n('Auth URL is required')
                },
                username: {
                    type: 'string',
                    required: true,
                    allowEmpty: false,
                    message: i18n('Username is required')
                },
                password: {
                    type: 'string',
                    required: true,
                    allowEmpty: false,
                    message: i18n('Password is required')
                }
            }
        }
    }
}

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations,

    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },

    _onDelete: function () {
        window.location.href = '#/integrations/'
    },

    render: function () {
        const object = this.state.object
        const config = object.config || {}

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Eyeride connection configuration')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('Base URL')}
                        name="config.baseUrl"
                        value={config.baseUrl}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.baseUrl')}
                        hasFeedback
                        help={this.errorsFor('config.baseUrl')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Auth URL')}
                        name="config.authUrl"
                        value={config.authUrl}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.authUrl')}
                        hasFeedback
                        help={this.errorsFor('config.authUrl')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Username')}
                        name="config.username"
                        value={config.username}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.username')}
                        hasFeedback
                        help={this.errorsFor('config.username')}
                    />

                    <FormGroup
                        type="password"
                        label={i18n('Password')}
                        name="config.password"
                        value={config.password}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.password')}
                        hasFeedback
                        help={this.errorsFor('config.password')}
                    />
                </div>
            </FormBase>
        )
    }
})

export default Form
